import { Card } from "semantic-ui-react";

import db from "astrid-firebase/src/db";
import useDocumentData from "astrid-firestore/src/hooks/useDocumentData";

import Actions from "../../../ui/components/Actions/Actions";
import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import PriceInfo from "./components/PriceInfo";

export default function SuperAdminProductionPriceView({ id, productionId }) {
	const [price, loading, error] = useDocumentData(
		id && productionId && db.collection("productions").doc(productionId).collection("productionPrices").doc(id),
	);

	return (
		<LoadingContext data={price} loading={loading} error={error}>
			{price && (
				<Card.Group>
					<PriceInfo price={price} />
					<Actions data={price}>
						<Actions.ApprovalAction right="prices.approve" />
						<Actions.DeletionAction right="costs.delete" />
					</Actions>
				</Card.Group>
			)}
		</LoadingContext>
	);
}
